import { type VolumeBasedPriceV1 } from '@redteclab/api/clients/bully'

import { type VolumeBasedPrice } from '../../algolia'

export const mapAlgoliaVolumeBasedPrices = (
  volumeBasedPrices: VolumeBasedPrice[],
): VolumeBasedPriceV1[] => {
  const formattedVolumeBasedPrices: VolumeBasedPriceV1[] = []

  if (volumeBasedPrices.length === 0) {
    return formattedVolumeBasedPrices
  }

  for (const volumeBasedPrice of volumeBasedPrices) {
    const {
      discount_percentage_formated,
      quantity_threshold,
      unit_discount_price_formated,
      unit_origin_price_formated,
    } = volumeBasedPrice

    formattedVolumeBasedPrices.push({
      discountPercentage: discount_percentage_formated,
      quantityThreshold: quantity_threshold,
      unitDiscountPrice: unit_discount_price_formated,
      unitOriginPrice: unit_origin_price_formated,
    })
  }

  return formattedVolumeBasedPrices
}
